import { APP_SMART_LINK } from './app-store-links';
import { referralInstallLink } from './referral-share-link';
import { useStoredInvite } from './use-stored-invite';

/**
 * What the scan-to-install QR should encode: the inviter's referral link for someone who arrived through
 * an invite (see `useStoredInvite` for why every route to a phone must carry it), the plain install link
 * otherwise.
 *
 * Bare, with no desktop destination on it — a code is only ever scanned BY a phone, so naming one would
 * encode a longer string for a case that cannot arise and make the code denser to scan.
 */
export function useInstallQrLink(): string {
  const ref = useStoredInvite();
  return ref ? referralInstallLink(ref) : APP_SMART_LINK;
}
